import * as React from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { UriBuilder } from '../../Service/UriBuilder';
import { SharingProps } from './SharingProps';

export abstract class AbstractSharingLink<M extends SharingProps = SharingProps> extends React.PureComponent<M> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    protected buildSharingUri(model: JobCenterModelInterface): string {
        const uriBuilder = new UriBuilder();

        return uriBuilder.sharingUriForModel(model);
    }
}
